import React from 'react';
import { AlertTriangleIcon, HelpCircleIcon, CheckIcon } from 'lucide-react';
import { checklist } from '../data/checklist';
export function ChecklistSection() {
  return <section id="checkliste" className="py-16 lg:py-28 bg-[#0a0e1a] scroll-mt-16" data-id="element-12" data-mp="2ly2bpesyu07b">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13" data-mp="2m06c3mrnoh2u">
        <div className="max-w-3xl mb-14 lg:mb-20" data-id="element-14" data-mp="2qvu2g5hvjg9x">
          <h2 className="text-3xl lg:text-5xl font-bold text-white mb-5" data-id="element-15" data-mp="2c891oi8h1t56">
            Close CRM Agentur Checkliste: 6 Punkte vor der Unterschrift
          </h2>
          <p className="text-gray-400 text-lg leading-relaxed" data-id="element-16" data-mp="2h0jyvdbtv0u1">
            Viele dieser Punkte haben Kunden vorher gar nicht auf dem Schirm –
            langfristig sorgen sie aber für die größten Probleme. Nimm die
            Fragen mit in jedes Erstgespräch.
          </p>
        </div>

        <div className="grid lg:grid-cols-12 gap-12" data-id="element-17" data-mp="1tapqp92ge0g4">
          <nav aria-label="Checkliste" className="hidden lg:block lg:col-span-4" data-id="element-18" data-mp="1y87ygw4qi9mj">
            <ol className="sticky top-28 space-y-1" data-id="element-19" data-mp="1yac4pkq3vkpz">
              {checklist.map((item, i) => <li key={item.id} data-id="element-20" data-mp="1dtk0yv7guj10" data-mpi={i}>
                  <a href={`#${item.id}`} className="flex items-center gap-4 py-3 px-4 -mx-4 rounded-lg text-gray-400 hover:text-white hover:bg-white/5 transition-colors" data-id="element-21" data-mp="1ducxz4gmhu5y">
                    <span className="text-sm font-mono text-[#ff6b35] w-6" data-id="element-22" data-mp="1mv1dy4pku4lh">
                      {i + 1}
                    </span>
                    <span className="font-medium" data-id="element-23" data-mp="v32cj2to29lg">{item.shortTitle}</span>
                  </a>
                </li>)}
            </ol>
          </nav>

          <ol className="lg:col-span-8 space-y-16 lg:space-y-20" data-id="element-24" data-mp="18w1sf5xd25tj">
            {checklist.map((item, i) => <li key={item.id} id={item.id} className="scroll-mt-28" data-id="element-25" data-mp="141npmigdcweu" data-mpi={i}>
                <article data-id="element-26" data-mp="gcv1v99whuvb">
                  <div className="flex items-start gap-5 mb-6" data-id="element-27" data-mp="gc353v4khr3g">
                    <span className="flex-shrink-0 w-11 h-11 rounded-full border border-[#ff6b35]/40 text-[#ff6b35] font-bold flex items-center justify-center" data-id="element-28" data-mp="be1pxla9ibx9">
                      {i + 1}
                    </span>
                    <h3 className="text-2xl lg:text-3xl font-bold text-white leading-tight pt-1" data-id="element-29" data-mp="2geum9afpds93">
                      {item.title}
                    </h3>
                  </div>

                  <div className="sm:pl-16 space-y-6" data-id="element-30" data-mp="2q57610fp1he6">
                    <div data-id="element-31" data-mp="1sigiq7lx0wmq">
                      <p className="flex items-center gap-2 text-sm font-semibold text-gray-300 mb-2" data-id="element-32" data-mp="1sj9slhg68293">
                        <AlertTriangleIcon className="w-4 h-4 text-amber-400" aria-hidden="true" data-id="element-33" data-mp="1xgrtqlny5d6j" />
                        Was in der Praxis schiefläuft
                      </p>
                      <p className="text-gray-400 leading-relaxed" data-id="element-34" data-mp="26hzl0js1pdr4">{item.problem}</p>
                    </div>

                    <div className="bg-[#111827] border border-white/10 rounded-xl p-6" data-id="element-35" data-mp="3dwkw0zqdh0vz">
                      <p className="flex items-center gap-2 text-sm font-semibold text-white mb-4" data-id="element-36" data-mp="3hwvcx7fpdbpm">
                        <HelpCircleIcon className="w-4 h-4 text-[#ff6b35]" aria-hidden="true" data-id="element-37" data-mp="16akt8afyk25e" />
                        Frag deine Agentur konkret
                      </p>
                      <ul className="space-y-3" data-id="element-38" data-mp="12atwzr7nwtth">
                        {item.questions.map(q => <li key={q} className="flex gap-3 text-gray-300 leading-relaxed" data-id="element-39" data-mp="sio50hheucea">
                            <span className="mt-2.5 w-1.5 h-1.5 rounded-full bg-[#ff6b35] flex-shrink-0" data-id="element-40" data-mp="sgtrvpcdrokr" />
                            {q}
                          </li>)}
                      </ul>
                    </div>

                    <p className="flex gap-3 text-gray-300 leading-relaxed" data-id="element-41" data-mp="ejwroxadgur7">
                      <CheckIcon className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-42" data-mp="9kbtip310qfj" />
                      <span data-id="element-43" data-mp="28x68791c5giy">
                        <span className="font-semibold text-white" data-id="element-44" data-mp="28web1ts3baqk">Bei CRM Kraft: </span>
                        {item.ourAnswer}
                      </span>
                    </p>
                  </div>
                </article>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}